// namespace
export const SALES_DASHBOARD= 'salesDashBoard'

// mutations
export const SET_ABO_INFO = 'setAboInfo';
export const SET_ATTAINMENT = 'setAttainment';
export const SET_ABO_CARD_LIST = 'setAboCardList';
export const SET_MESSAGE_BOX = 'setMessageBox';

export const SET_INIT_COMPLETED = 'setInitcompled';
export const SET_EOS = 'setEos';
export const SET_EFFECT_FLAG = 'setEffectFlag';
export const SET_SHOW_EFFECT_FLAG = 'setShowEffectFlag';


// getters
export const GET_ABO_INFO = 'getAboInfo';
export const GET_ATTAINMENT = 'getAttainment';
export const GET_ABO_CARD_LIST = 'getAboCardList';
export const GET_EOS = 'getEos';
export const GET_INIT_COMPLETED = 'getInitCompleted';
export const GET_EFFECT_FLAG = 'getEffectFlag';
export const GET_SHOW_EFFECT_FLAG = 'getShowEffectFlag';
export const GET_MESSAGES = 'getMessages';


// actions
export const FETCH_ATTAINMENT_INFO = 'fetchAboInfo';
export const FETCH_EFFECT_SAVE = 'fetchEffectSave';
